import { badgePrinterDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const printerSchema = dataEnvelopeSchema(badgePrinterDTOSchema);
const printerListSchema = dataEnvelopeSchema(z.array(badgePrinterDTOSchema));
const BADGE_PRINTERS_PATH = `${WEB_API_PREFIX}/visitor/badge-printers`;
/** A SECOND constant, not a string built inline: the device mapping lives under `/devices`,
 *  not under `/badge-printers`, so it is a different route and gets its own name. */
const VISITOR_DEVICES_PATH = `${WEB_API_PREFIX}/visitor/devices`;
export function createBadgePrintersResource(transport) {
    return {
        async list(query = {}) {
            const envelope = await transport.request({
                path: BADGE_PRINTERS_PATH,
                query,
                schema: printerListSchema,
            });
            return envelope.data;
        },
        async register(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: BADGE_PRINTERS_PATH,
                schema: printerSchema,
                body: input,
            });
            return envelope.data;
        },
        async update(id, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: `${BADGE_PRINTERS_PATH}/${encodeURIComponent(id)}`,
                schema: printerSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(id) {
            await transport.request({
                method: 'DELETE',
                path: `${BADGE_PRINTERS_PATH}/${encodeURIComponent(id)}`,
                schema: z.undefined(),
            });
        },
        async setDevicePrinter(deviceId, badgePrinterId) {
            await transport.request({
                method: 'PUT',
                path: `${VISITOR_DEVICES_PATH}/${encodeURIComponent(deviceId)}/badge-printer`,
                schema: z.undefined(),
                body: { badgePrinterId },
            });
        },
    };
}
//# sourceMappingURL=badge-printers.js.map